import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-info-modal',
    templateUrl: './info-modal.component.html',
    styleUrls: ['./info-modal.component.scss']
})
export class InfoModalComponent implements OnInit {
    @Input() header: string = '';
    @Input() message: string = '';
    @Input() icon: string = '';
    @Input() buttonText: string = '';

    constructor(
        private modalController: ModalController,
        public sanitizer: DomSanitizer
    ) {}

    ngOnInit() {
    }

    dismiss() {
        this.modalController.dismiss();
    }
}
